import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import $ from "jquery";
import { Get_Company_Logo } from "./ReduxStore/Slice/Admin/AdminSlice";
import {
  // UPDATE_LANDING_PAGE_PERMISSION,
  GET_LANDING_PAGE_PERMISSION,
} from "./ReduxStore/Slice/Admin/AdminHelpSlice";

import {
  GET_ALL_PLANS,
} from "./ReduxStore/Slice/Admin/planSlice";

export default function TradetronLanding() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const token = localStorage.getItem("token")
  const [getCompanyName, setGetCompanyName] = useState("");
  const [theme, setTheme] = useState("dark");
  const [permissions, setPermissions] = useState([
    // { key: "landing_page_permission", label: "Landing Page Permission", value: 0 },
    // { key: "trade_permission", label: "Trade Permission", value: 0 },
    // { key: "withdraw_permission", label: "Withdraw Permission", value: 0 },
    // { key: "deposit_permission", label: "Deposit Permission", value: 0 },
    { key: "plan_permission", label: "Plan Permission", value: 0 },
    { key: "Marketplace_permission", label: "FAQ Permission", value: 0 },
  ]);
  const [dynamicPlans, setDynamicPlans] = useState([]);
  const [plansLoading, setPlansLoading] = useState(true);

  const fetchDynamicPlans = async () => {
    try {
      setPlansLoading(true);
      const res = await dispatch(GET_ALL_PLANS({ token })).unwrap();

      if (res?.data && Array.isArray(res.data)) {
        const activePlans = res.data.filter(plan => plan.is_active === 1);
        setDynamicPlans(activePlans);
      }
    } catch (error) {
      console.error("Error fetching plans:", error);
      setDynamicPlans([]);
    } finally {
      setPlansLoading(false);
    }
  };

  useEffect(() => {
    if (checkPermission("plan_permission")) {
      fetchDynamicPlans();
    }
  }, [permissions]);

  const CompanyName = async () => {
    await dispatch(Get_Company_Logo())
      .unwrap()
      .then((response) => {
        if (response.status) {
          setGetCompanyName(response.data && response.data[0].panel_name);
          $(".logo-abbr").attr("src", response.data && response.data[0].logo);
          $(".Company_logo").html(response.data && response.data[0].panel_name);

          $("body").removeClass().addClass(response.data[0].theme_name);

          const incomingTheme = response.data[0].theme_name || "dark";
          setTheme(incomingTheme.includes("dark") ? "dark" : "light");
          let favicon = $("link[rel='icon']").length
            ? $("link[rel='icon']")
            : $("<link rel='icon' type='image/x-icon' />");
          favicon.attr("href", response.data && response.data[0].favicon);
          $("head").append(favicon);
        }
      })
      .catch(() => { });
  };

  useEffect(() => {
    CompanyName();
  }, []);

  useEffect(() => {
    dispatch(GET_LANDING_PAGE_PERMISSION({ token }))
      .unwrap()
      .then((res) => {
        if (res?.success && res?.data) {
          const updated = permissions.map((item) => ({
            ...item,
            value: res.data[item.key] ?? 0,
          }));
          setPermissions(updated);
        }
      });
  }, []);


  const checkPermission = (key) => {
    const item = permissions.find((p) => p.key === key);
    return item?.value === 1;
  };

  const AnchorLink = ({ to, className, children }) => (
    <a
      href={to}
      className={className}
      onClick={(e) => {
        e.preventDefault();
        const id = to.replace("#", "");
        const el = document.getElementById(id);
        el?.scrollIntoView({ behavior: "smooth", block: "start" });
        // sticky navbar offset (optional fallback)
        // window.location.hash = to;
      }}
    >
      {children}
    </a>
  );

  // Mock ticker data (replace with live feed later)
  const tickers = [
    { s: "BTC/USDT", p: 67892.15, chg: +1.82 },
    { s: "ETH/USDT", p: 3550.44, chg: -0.64 },
    { s: "SOL/USDT", p: 187.23, chg: +3.12 },
    { s: "ADA/USDT", p: 0.66, chg: +0.91 },
    { s: "XRP/USDT", p: 0.72, chg: -0.35 },
  ];

  // Mini sparkline SVG
  const Spark = ({ up = true }) => (
    <svg width="80" height="28" viewBox="0 0 80 28" preserveAspectRatio="none">
      <polyline
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        points={
          up
            ? "0,20 10,22 20,18 30,19 40,14 50,16 60,10 70,12 80,6"
            : "0,6 10,8 20,12 30,10 40,14 50,12 60,18 70,16 80,22"
        }
      />
    </svg>
  );

  const chipVariants = [
    "icon-green",
    "icon-violet",
    "icon-orange",
    "icon-cyan",
    "icon-pink",
    "icon-amber",
    "icon-blue",
  ];



  return (
    <div
      data-bs-theme={theme}
      className="landing-root bg-body text-body home-container"
    >
      {/* Background accents */}
      <div className="hero-gradient-1" />
      <div className="hero-gradient-2" />

      {/* NAVBAR */}
      <nav
        className="navbar navbar-expand-lg bg-body position-sticky top-0 border-bottom"
        style={{ zIndex: 20 }}
      >
        <div className="container py-2">
          <a
            className="navbar-brand d-flex align-items-center gap-2 fw-bold"
            href="#"
          >
            <img
              className="logo-abbr"
              width="150"
              height="32"
              alt="logo"
              style={{ width: "150px", height: "auto" }}
            />
            {/* <span className="Company_logo" style={{ color: "#ff6b6b" }}>{getCompanyName || "CRYPTO HUB"}</span> */}
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#nav"
          >
            <span className="navbar-toggler-icon" />
          </button>
          <div id="nav" className="collapse navbar-collapse">
            <ul className="navbar-nav ms-auto align-items-lg-center">
              <li className="nav-item">
                <AnchorLink to="#market" className="nav-link">
                  Market
                </AnchorLink>
              </li>
              <li className="nav-item">
                <AnchorLink to="#why-choose" className="nav-link">
                  Why Choose
                </AnchorLink>
              </li>
              <li className="nav-item">
                <AnchorLink to="#supported" className="nav-link">
                  Supported Crypto
                </AnchorLink>
              </li>
              <li className="nav-item">
                <AnchorLink to="#features" className="nav-link">
                  Features
                </AnchorLink>
              </li>

              <li className="nav-item">
                <AnchorLink to="#faq" className="nav-link">
                  FAQ
                </AnchorLink>
              </li>
            </ul>

            <div className="d-flex ms-lg-3 gap-2 mt-3 mt-lg-0">
              <button
                onClick={() => setTheme(theme === "light" ? "dark" : "light")}
                className="btn btn-ghost btn-sm"
              >
                {theme === "light" ? "Dark" : "Light"} Mode
              </button>
              <button
                onClick={() => navigate("/login")}
                className="btn btn-gradient-primary"
              >
                Launch App
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* TICKER */}
      <div className="border-bottom bg-body">
        <div className="container py-2 overflow-hidden">
          <div className="d-flex gap-4 flex-nowrap ticker-marquee">
            {tickers.concat(tickers).map((t, i) => (
              <div
                key={i}
                className="small text-nowrap d-flex align-items-center gap-2"
              >
                <span className="fw-semibold">{t.s}</span>
                <span className="badge bg-body-secondary text-body fw-normal">
                  {t.p.toLocaleString()}
                </span>
                <span
                  className={`fw-semibold ${t.chg >= 0 ? "text-success" : "text-danger"
                    }`}
                >
                  {t.chg > 0 ? "+" : ""}
                  {t.chg}%
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* HERO */}
      <header className="py-lg-5 py-4 position-relative">
        <div className="container position-relative" style={{ zIndex: 1 }}>
          <div className="row align-items-center g-5">
            <div className="col-12 col-lg-6">
              <span className="badge bg-primary-subtle text-primary mb-3">
                Pro Grade Crypto Automation
              </span>
              <h1 className="display-5 fw-bold lh-tight mb-3">
                Trade like a desk.{" "}
                <span style={{ color: "var(--content-heading-color)" }}>
                  Automate
                </span>{" "}
                your edge.
              </h1>
              <p className="lead text-secondary mb-4">
                Backtest, paper, and deploy 24/7 strategies across Delta,
                CoinDCX and CoinSwitch with risk caps and smart routing.
              </p>
              <div className="d-flex flex-wrap gap-2 mt-2">
                <button
                  className="btn btn-gradient-primary "
                  onClick={() => navigate("/login")}
                >
                  Start Free
                </button>
                <a href="#strategies" className="btn btn-ghost ">
                  Explore Strategies
                </a>
              </div>
              <div className="d-flex align-items-center gap-3 mt-4 small text-secondary">
                <span className="badge bg-success-subtle text-success">
                  99.9% Uptime
                </span>
                <div className="vr" />
                <span>SOC2-ready • API key vaulting</span>
              </div>
            </div>

            <div className="col-12 col-lg-6">
              {/* Glass Dashboard Mock */}
              <div className="card border-0 shadow-xl rounded-4 glass-card overflow-hidden">
                <div className="p-3 border-bottom d-flex gap-2">
                  <span className="badge bg-primary">Positions</span>
                  <span className="badge bg-primary">Orders</span>
                  <span className="badge bg-primary">P&L</span>
                </div>
                <div className="p-3">
                  <div className="table-responsive">
                    <table className="table align-middle mb-0">
                      <thead className="small text-secondary">
                        <tr>
                          <th>Symbol</th>
                          <th>Side</th>
                          <th>Qty</th>
                          <th>Avg</th>
                          <th>Last</th>
                          <th>P&L</th>
                        </tr>
                      </thead>
                      <tbody>
                        {[
                          {
                            s: "BTC-PERP",
                            side: "Long",
                            q: 0.25,
                            a: 67450,
                            l: 67892,
                            pnl: +110.2,
                          },
                          {
                            s: "ETH-PERP",
                            side: "Short",
                            q: 2,
                            a: 3568,
                            l: 3550,
                            pnl: +36.0,
                          },
                          {
                            s: "SOL-PERP",
                            side: "Long",
                            q: 30,
                            a: 183.5,
                            l: 187.2,
                            pnl: +111.0,
                          },
                        ].map((r, i) => (
                          <tr key={i}>
                            <td className="fw-semibold">{r.s}</td>
                            <td>
                              <span
                                className={`badge ${r.side === "Long"
                                  ? "bg-success-subtle text-success"
                                  : "bg-danger-subtle text-danger"
                                  }`}
                              >
                                {r.side}
                              </span>
                            </td>
                            <td>{r.q}</td>
                            <td>{r.a}</td>
                            <td>{r.l}</td>
                            <td
                              className={
                                r.pnl >= 0 ? "text-success" : "text-danger"
                              }
                            >
                              {r.pnl >= 0 ? "+" : ""}
                              {r.pnl.toFixed(1)}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="d-flex justify-content-between align-items-center mt-3">
                    <div className="small text-secondary">
                      Latency ~42ms • Fill rate 99.2%
                    </div>
                    <button className="btn btn-sm btn-gradient-primary">
                      Deploy Strategy
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* TRUST BAR */}
      {/* <section className="py-4 border-top border-bottom bg-body">
        <div className="container">
          <div className="d-flex flex-wrap gap-4 justify-content-center align-items-center opacity-75">
            {["Delta Exchange","CoinDCX","CoinSwitch","TradingView","Telegram"].map((x,i)=> (
              <div key={i} className="d-flex align-items-center gap-2 small text-secondary">
                <div className="rounded-2 bg-body-secondary" style={{ width: 28, height: 28 }} /> {x}
              </div>
            ))}
          </div>
        </div>
      </section> */}

      {/* STRATEGY MARKETPLACE */}
      {/* {checkPermission("Marketplace_permission") && ( */}
      <section id="market" className="py-5 bg-body-tertiary">
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="fw-bold mb-2">Strategy Marketplace</h2>
            <p className="text-secondary mb-0">
              Handpicked crypto algos with transparent stats.
            </p>
          </div>
          <div className="row g-4">
            {[
              {
                name: "Momentum Pulse",
                ret: "+38.4% YTD",
                risk: "Medium",
                up: true,
              },
              {
                name: "Mean Revert X",
                ret: "+21.7% YTD",
                risk: "Low",
                up: true,
              },
              {
                name: "Vol Breakout",
                ret: "+12.9% YTD",
                risk: "High",
                up: false,
              },
              { name: "Carry Perp", ret: "+16.1% YTD", risk: "Low", up: true },
              {
                name: "Grid Alpha",
                ret: "+9.8% YTD",
                risk: "Medium",
                up: false,
              },
              { name: "Arb Mesh", ret: "+24.3% YTD", risk: "Medium", up: true },
            ].map((s, i) => (
              <div className="col-12 col-md-6 col-lg-4" key={i}>
                <div className="card h-100 border-0 rounded-4 shadow-sm hover-lift">
                  <div className="card-body p-4 d-flex flex-column">
                    <div className="d-flex justify-content-between align-items-start mb-2">
                      <h5 className="fw-bold mb-0">{s.name}</h5>
                      <span
                        className={`badge ${s.up
                          ? "bg-success-subtle text-success"
                          : "bg-danger-subtle text-danger"
                          }`}
                      >
                        {s.ret}
                      </span>
                    </div>
                    <div className="text-secondary small mb-3">
                      Risk: {s.risk} • Assets: BTC, ETH, SOL
                    </div>
                    <div className="text-primary mb-3">
                      <Spark up={s.up} />
                    </div>
                    <div className="d-flex gap-2 mt-auto">
                      <button
                        className="btn btn-gradient-primary btn-sm"
                        onClick={() => navigate("/login")}
                      >
                        Try Paper
                      </button>
                      <button className="btn btn-ghost btn-sm">
                        View Logic
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* )} */}

      {/* WHY CHOOSE — Dark-mode synced + colorful chips */}
      <section className="py-5 bg-body" id="why-choose">
        <div className="container">
          <h2 className="text-center fw-bold mb-2">
            Why Choose Tradetron’s Crypto Algo Platform?
          </h2>
          <p className="text-center text-secondary mb-4">
            Build, backtest, and automate — safely and at scale.
          </p>

          <div className="text-center mb-5">
            <button
              className="btn btn-gradient-primary px-4"
              onClick={() =>
                document
                  .querySelector("#strategies")
                  ?.scrollIntoView({ behavior: "smooth" })
              }
            >
              Explore Multiple Strategies
            </button>
          </div>

          <div className="row g-4">
            {[
              {
                icon: (
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M3 13h8V3H3zm10 8h8V11h-8z" />
                  </svg>
                ),
                t: "Automated Crypto Trading",
                d: "Execute 24/7 with rules, guards, and smart routing.",
              },
              {
                icon: (
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M4 4h7v7H4zM13 4h7v7h-7zM4 13h7v7H4zM13 13h7v7h-7z" />
                  </svg>
                ),
                t: "Pro-Grade Architecture",
                d: "Low latency infra, resilient queues, live monitoring.",
              },
              {
                icon: (
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M3 3h18v2H3zm0 7h18v2H3zm0 7h18v2H3z" />
                  </svg>
                ),
                t: "Prebuilt + Custom Strategies",
                d: "Use templates or compose your own with a rule builder.",
              },
              {
                icon: (
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M7 14l5-5 5 5z" />
                  </svg>
                ),
                t: "Scalping & Derivatives",
                d: "Optimized for high-frequency and perpetuals/options.",
              },
              {
                icon: (
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M12 2l9 4v6c0 5-3.8 9.7-9 10-5.2-.3-9-5-9-10V6l9-4z" />
                  </svg>
                ),
                t: "Risk Controls",
                d: "Daily loss caps, trailing exits, hedges, and baskets.",
              },
              {
                icon: (
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M12 22l-8-4V6l8-4 8 4v12z" />
                  </svg>
                ),
                t: "Signals & Alerts",
                d: "Webhooks, Telegram, Discord, email — in real time.",
              },
              {
                icon: (
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M5 12l5 5L20 7" />
                  </svg>
                ),
                t: "Exchange Integrations",
                d: "Delta, CoinDCX, CoinSwitch — OAuth linking, key vaulting.",
              },
            ].map((f, i) => (
              <div className="col-12 col-md-6 col-lg-4" key={i}>
                <div className="card h-100 border-0 shadow-sm rounded-4 feature-card bg-body">
                  <div className="card-body p-4 d-flex">
                    <div
                      className={`icon-chip me-3 ${chipVariants[i % chipVariants.length]
                        }`}
                    >
                      {f.icon}
                    </div>
                    <div>
                      <h6 className="fw-bold mb-1">{f.t}</h6>
                      <p className="text-secondary mb-0">{f.d}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SUPPORTED EXCHANGES — Dark-mode synced */}
      <section className="py-5 bg-body-tertiary" id="supported">
        <div className="container">
          <div className="row align-items-center g-4">
            <div className="col-lg-6">
              <div className="card border-0 shadow-sm rounded-4 overflow-hidden bg-body">
                <div className="ratio ratio-16x9">
                  <img
                    src="https://img.freepik.com/premium-vector/business-trading-chart-investment-map-white-background-candlestick-analysis-graph-trend_252172-1413.jpg?w=1060"
                    alt="ETRADE from Morgan Stanley Home page"
                    className="w-100 h-100 object-fit-cover"
                  ></img>
                </div>
                <div className="card-body d-flex flex-wrap gap-2">
                  {[
                    "Delta Exchange",
                    "CoinDCX",
                    "CoinSwitch",
                    "OAuth",
                    "WebSockets",
                  ].map((t) => (
                    <span
                      key={t}
                      className="badge bg-secondary-subtle text-body"
                    >
                      {t}
                    </span>
                  ))}
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <h2 className="fw-bold mb-2">
                Supported Crypto Exchanges & Payment Methods
              </h2>
              <p className="text-secondary">
                Seamless connectivity with secure OAuth, granular permissions,
                and vault-backed API keys.
              </p>

              <ul className="list-unstyled d-grid gap-2 text-secondary mb-4">
                {[
                  "Real-time balances, positions, and fills",
                  "Rate-limit aware smart routing",
                  "Spot & derivatives ready",
                  "Multi-account mirroring",
                ].map((li) => (
                  <li key={li} className="d-flex align-items-start gap-2">
                    <span className="text-success mt-1">●</span> {li}
                  </li>
                ))}
              </ul>

              <div className="d-flex flex-wrap gap-3 mb-4">
                {[
                  { h: "99.9%", s: "Uptime" },
                  { h: "~42ms", s: "Avg Latency" },
                  { h: "3", s: "Exchanges" },
                ].map((x) => (
                  <div key={x.s} className="stat-tile">
                    <div className="fw-bold">{x.h}</div>
                    <div className="small text-secondary">{x.s}</div>
                  </div>
                ))}
              </div>

              <a href="#strategies" className="btn btn-gradient-primary px-4">
                Connect an Exchange
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* GET STARTED + TT ML — Dark-mode synced */}
      <section className="py-5 bg-body" id="features">
        <div className="container">
          <div className="text-center mb-4">
            <h2 className="fw-bold">
              Get Started with Fully Automated Algo Trading
            </h2>
            <p className="text-secondary mb-0">
              Go from idea → backtest → paper → live, with built-in risk
              controls.
            </p>
          </div>

          {/* Steps */}
          <div className="row g-4 mb-4">
            {[
              {
                step: "1",
                h: "Backtest",
                p: "Validate your logic with tick-aware backtests.",
              },
              {
                step: "2",
                h: "Paper Trade",
                p: "Trial run with real markets, zero risk.",
              },
              {
                step: "3",
                h: "Deploy",
                p: "Connect exchange & automate with guards.",
              },
            ].map((it) => (
              <div className="col-md-4" key={it.step}>
                <div className="card h-100 border-0 shadow-sm rounded-4 bg-body">
                  <div className="card-body p-4">
                    <div className="step-dot mb-3">{it.step}</div>
                    <h5 className="fw-bold mb-1">{it.h}</h5>
                    <p className="text-secondary mb-0">{it.p}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Exchanges trio */}
          <div className="row g-4 mb-5">
            {[
              {
                h: "Delta Exchange",
                p: "Perpetuals & options, deep liquidity. Ideal for derivatives algos.",
                tag: "Derivatives",
              },
              {
                h: "CoinDCX",
                p: "India’s leading exchange with robust spot/derivs APIs.",
                tag: "Spot & Derivs",
              },
              {
                h: "CoinSwitch",
                p: "Beginner-friendly experience with reliable execution.",
                tag: "Beginner Friendly",
              },

            ].map((card) => (
              <div className="col-md-4" key={card.h}>
                <div
                  className="card h-100 border-0 rounded-4 exchange-card"
                  style={{
                    background:
                      "linear-gradient(135deg, var(--surface-1) 0%, var(--bs-body-bg) 100%)",
                  }}
                >
                  <div className="card-body p-4 d-flex flex-column">
                    <span className="badge align-self-start bg-primary-subtle text-primary mb-2">
                      {card.tag}
                    </span>
                    <h5 className="fw-bold">{card.h}</h5>
                    <p className="text-secondary mb-3">{card.p}</p>
                    <div className="mt-auto">
                      <button className="btn btn-ghost btn-sm me-2">
                        Learn more
                      </button>
                      <button className="btn btn-gradient-primary btn-sm">
                        Link account
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* TT ML Block */}
          <div className="p-5 rounded-4 bg-body-tertiary d-lg-flex align-items-center justify-content-between">
            <div className="me-lg-4">
              <h3 className="fw-bold mb-2">TT ML — Algo Trading Academy</h3>
              <p className="text-secondary mb-0">
                Free webinars, strategy templates, and live builds to take you
                from paper to production.
              </p>
            </div>
            <div className="mt-3 mt-lg-0">
              <button
                onClick={() => navigate("/login")}
                className="btn btn-gradient-primary  px-4"
              >
                Sign up for Free
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* PLANS SECTION */}
      {checkPermission("plan_permission") && (
        <section className="py-5 bg-body" id="plans">
          <div className="container">
            {/* Heading */}
            <div className="text-center mb-4">
              <h2 className="fw-bold">Choose Your Trading Plan</h2>
              <p className="text-secondary mb-0">
                Simple, transparent pricing. Upgrade anytime as you scale.
              </p>
            </div>

            {/* Loading State */}
            {plansLoading ? (
              <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading plans...</span>
                </div>
                <p className="text-muted mt-3">Loading plans...</p>
              </div>
            ) : dynamicPlans.length === 0 ? (
              <div className="text-center py-5">
                <p className="text-muted">No plans available at the moment.</p>
              </div>
            ) : (
              <>
                {/* Plans Cards - DYNAMIC */}
                <div className="row g-4 mb-4">
                  {dynamicPlans.map((plan) => (
                    <div
                      className={`col-md-${dynamicPlans.length === 1 ? '12' : dynamicPlans.length === 2 ? '6' : '4'}`}
                      key={plan._id}
                    >
                      <div
                        className="card h-100 border-0 rounded-4 exchange-card"
                        style={{
                          background:
                            "linear-gradient(135deg, var(--surface-1) 0%, var(--bs-body-bg) 100%)",
                        }}
                      >
                        <div className="card-body p-4 d-flex flex-column">
                          {/* Plan Type Badge */}
                          <span
                            className={`badge mb-2 ${plan.plan_type === 'basic'
                              ? 'bg-info-subtle text-info'
                              : plan.plan_type === 'premium'
                                ? 'bg-primary-subtle text-primary'
                                : 'bg-success-subtle text-success'
                              }`}
                          >
                            {plan.plan_type.charAt(0).toUpperCase() + plan.plan_type.slice(1)}
                          </span>

                          {/* Plan Name */}
                          <h4 className="fw-bold mb-1">{plan.plan_name}</h4>

                          {/* Plan Price */}
                          <h3 className="fw-bold text-primary mb-2">
                            {plan.currency === "INR" ? "₹" : "$"}
                            {plan.plan_price}
                            <span className="fs-6 text-secondary fw-normal">
                              {' '}/ {plan.plan_duration} month
                            </span>
                          </h3>


                          {/* Plan Description */}
                          {plan.plan_description && (
                            <p className="text-secondary">{plan.plan_description}</p>
                          )}

                          {/* Features List */}
                          {plan.plan_features && plan.plan_features.length > 0 && (
                            <ul className="list-unstyled text-secondary small mb-3">
                              {plan.plan_features.map((feature, idx) => (
                                <li key={idx} className="mb-1">
                                  • {feature}
                                </li>
                              ))}
                            </ul>
                          )}

                          {/* Action Buttons */}
                          <div className="mt-auto">
                            <button className="btn btn-ghost btn-sm me-2">
                              Learn more
                            </button>
                            <button
                              className="btn btn-gradient-primary btn-sm"
                              onClick={() => navigate("/login")}
                            >
                              Get Started
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Extra CTA Block */}
                <div className="p-5 rounded-4 bg-body-tertiary d-lg-flex align-items-center justify-content-between">
                  <div className="me-lg-4">
                    <h3 className="fw-bold mb-2">Not sure which plan fits you?</h3>
                    <p className="text-secondary mb-0">
                      Join a free onboarding call with our experts to choose the best plan.
                    </p>
                  </div>
                  {/* <div className="mt-3 mt-lg-0">
                    <button className="btn btn-gradient-primary px-4">
                      Book Free Demo
                    </button>
                  </div> */}
                </div>
              </>
            )}
          </div>
        </section>
      )}


      {/* TESTIMONIALS */}
      <section className="py-5 bg-body-tertiary">
        <div className="container">
          <div className="text-center mb-4">
            <h2 className="fw-bold">What traders say</h2>
          </div>
          <div id="tcar" className="carousel slide" data-bs-ride="carousel">
            <div className="carousel-inner">
              {[
                {
                  t: "Cut my manual clicks by 90%. Paper to live in a day.",
                  a: "Nikhil, Quant Dev",
                },
                {
                  t: "Backtests match live slippage closely. Trustworthy.",
                  a: "Sana, Options Trader",
                },
                {
                  t: "Multi-account mirroring is a game changer.",
                  a: "Ravi, Prop Desk",
                },
              ].map((x, i) => (
                <div
                  className={`carousel-item ${i === 0 ? "active" : ""}`}
                  key={i}
                >
                  <div className="row justify-content-center">
                    <div className="col-12 col-lg-8">
                      <div className="card border-0 shadow-sm rounded-4">
                        <div className="card-body p-4 text-center">
                          <p className="lead mb-2">“{x.t}”</p>
                          <div className="small text-secondary">{x.a}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <button
              className="carousel-control-prev"
              type="button"
              data-bs-target="#tcar"
              data-bs-slide="prev"
            >
              <span className="carousel-control-prev-icon" />
            </button>
            <button
              className="carousel-control-next"
              type="button"
              data-bs-target="#tcar"
              data-bs-slide="next"
            >
              <span className="carousel-control-next-icon" />
            </button>
          </div>
        </div>
      </section>

      {/* FAQ */}
      {checkPermission("Marketplace_permission") && (
        <section id="faq" className="py-5 bg-body">
          <div className="container">
            <div className="text-center mb-4">
              <h2 className="fw-bold">FAQs</h2>
            </div>
            <div className="row justify-content-center">
              <div className="col-12 col-lg-10">
                <div className="accordion" id="faqAcc">
                  {[
                    {
                      q: "Is it fully automated?",
                      a: "Yes. Go fully hands-off with risk caps or semi-auto with confirms.",
                    },
                    {
                      q: "Do you support paper trading?",
                      a: "Yes. Backtest → paper → live deploy.",
                    },
                    {
                      q: "Which exchanges are supported?",
                      a: "Delta Exchange, CoinDCX, and CoinSwitch.",
                    },
                    {
                      q: "Can I mirror across accounts?",
                      a: "Yes. Use multi-account routing & allocations.",
                    },
                  ].map((item, idx) => (
                    <div
                      className="accordion-item border-0 shadow-sm rounded-3 mb-3"
                      key={idx}
                    >
                      <h2 className="accordion-header" id={`h-${idx}`}>
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target={`#c-${idx}`}
                          aria-expanded="false"
                          aria-controls={`c-${idx}`}
                        >
                          {item.q}
                        </button>
                      </h2>
                      <div
                        id={`c-${idx}`}
                        className="accordion-collapse collapse"
                        aria-labelledby={`h-${idx}`}
                        data-bs-parent="#faqAcc"
                      >
                        <div className="accordion-body">{item.a}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
      {/* CTA */}
      <section className="py-5 bg-body-tertiary position-relative">
        <div className="container text-center">
          <h2 className="fw-bold mb-2">Ready to automate?</h2>
          <p className="text-secondary mb-4">
            Join thousands of algo traders building with Tradetron.
          </p>
          <button
            className="btn btn-gradient-primary "
            onClick={() => navigate("/login")}
          >
            Launch Free
          </button>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="bg-body border-top py-5">
        <div className="container">
          <div className="row g-4">
            <div className="col-6 col-md-4">
              <h6 className="fw-bold mb-3">TRADETRON</h6>
              <ul className="list-unstyled small text-secondary d-grid gap-2">

                <li>
                  <a href="#market" className="text-decoration-none">
                    Market
                  </a>
                </li>

                <li>
                  <a href="#strategies" className="text-decoration-none">
                    Strategies
                  </a>
                </li>
                <li>
                  <a href="#faq" className="text-decoration-none">
                    Support
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-6 col-md-4">
              <h6 className="fw-bold mb-3">Integrations</h6>
              <ul className="list-unstyled small text-secondary d-grid gap-2">
                <li>Delta Exchange</li>
                <li>CoinDCX</li>
                <li>CoinSwitch</li>
                <li>API Docs</li>
              </ul>
            </div>
            <div className="col-6 col-md-4">
              <h6 className="fw-bold mb-3">Legal</h6>
              <ul className="list-unstyled small text-secondary d-grid gap-2">
                <li>
                  <a href="#" className="text-decoration-none">
                    Privacy Policy
                  </a>
                </li>
                <li>
                  <a href="#" className="text-decoration-none">
                    Terms of Use
                  </a>
                </li>
                <li>
                  <a href="#" className="text-decoration-none">
                    Disclosure
                  </a>
                </li>
                <li>
                  <a href="#" className="text-decoration-none">
                    Sitemap
                  </a>
                </li>
              </ul>
            </div>
            {/* <div className="col-6 col-md-3">
              <div className="small text-secondary mt-3">
                © {new Date().getFullYear()} Tradetron • Trading Kit
              </div>
            </div> */}
          </div>
        </div>
      </footer>

      {/* Scoped Styles */}
      <style>{`
        .hover-lift { transition: transform .25s ease, box-shadow .25s ease; }
        .hover-lift:hover { transform: translateY(-4px); box-shadow: 0 1rem 2rem rgba(0,0,0,.08) !important; }
        .glass-card { backdrop-filter: blur(8px); background: rgba(var(--bs-body-bg-rgb), .65); }
        .ticker-marquee { animation: slide 24s linear infinite; }
        @keyframes slide { from { transform: translateX(0); } to { transform: translateX(-50%); } }
        .py-6 { padding-top: 6rem !important; padding-bottom: 6rem !important; }
        .hero-gradient-1, .hero-gradient-2 { position: fixed; inset: -10% -10% auto auto; pointer-events:none; z-index:0; }
        .hero-gradient-1 { width: 520px; height: 520px; border-radius: 50%; right: -140px; top: -140px; background: radial-gradient(50% 50% at 50% 50%, rgba(255,107,107,.28), rgba(255,107,107,0) 70%); }
        .hero-gradient-2 { width: 460px; height: 460px; border-radius: 50%; left: -120px; top: 40%; background: radial-gradient(50% 50% at 50% 50%, rgba(111,66,193,.22), rgba(111,66,193,0) 70%); }
        .shadow-xl { box-shadow: 0 1.5rem 3rem rgba(0,0,0,.12) !important; }
        .object-fit-cover { object-fit: cover; }

        /* --------- Fancy Buttons --------- */
        .btn-gradient-primary {
          background:var(--btn-background);
        //   background-image: linear-gradient(135deg, var(--g1), var(--g2));
          color: #fff !important;
          border: 0;
          box-shadow: 0 .5rem 1.25rem rgba(0,0,0,.15), 0 0 0 0 rgba(102,16,242,.6);
          transition: transform .15s ease, box-shadow .2s ease, filter .2s ease;
        }
          .btn:focus-visible, .btn:first-child:active,:not(.btn-check)+.btn:active
          {
           background:var(--btn-background) !important;
          }
        .btn-gradient-primary:hover {
          transform: translateY(-1px);
            background:var(--btn-background);
          box-shadow: 0 .75rem 1.5rem rgba(0,0,0,.18), 0 0 0 .2rem rgba(102,16,242,.25);
        //   filter: brightness(1.03);
        }
        .btn-gradient-primary:active { transform: translateY(0); }

        .btn-ghost {
          background: transparent;
          border: 1px solid var(--bs-border-color);
          color: var(--bs-body-color);
        }
        .btn-ghost:hover {
          background: var(--bs-body-bg);
          box-shadow: 0 .5rem 1rem rgba(0,0,0,.06);
        }

        /* --------- Icon Chips (colorful) --------- */
        .icon-chip {
          width: 44px; height: 44px; border-radius: 14px;
          display: inline-flex; align-items: center; justify-content: center;
          border: 1px solid var(--bs-border-color);
          background: var(--chip-bg, var(--bs-body-bg));
          color: var(--chip-fg, var(--bs-primary));
        }
        .icon-green  { --chip-bg: color-mix(in oklab, var(--bs-success) 14%, var(--bs-body-bg)); --chip-fg: var(--bs-success); }
        .icon-violet { --chip-bg: color-mix(in oklab, var(--bs-indigo) 16%, var(--bs-body-bg));  --chip-fg: var(--bs-indigo); }
        .icon-orange { --chip-bg: color-mix(in oklab, var(--bs-orange, #fd7e14) 18%, var(--bs-body-bg)); --chip-fg: var(--bs-orange, #fd7e14); }
        .icon-cyan   { --chip-bg: color-mix(in oklab, var(--bs-cyan, #0dcaf0) 18%, var(--bs-body-bg));   --chip-fg: var(--bs-cyan, #0dcaf0); }
        .icon-pink   { --chip-bg: color-mix(in oklab, var(--bs-pink, #d63384) 18%, var(--bs-body-bg));   --chip-fg: var(--bs-pink, #d63384); }
        .icon-amber  { --chip-bg: color-mix(in oklab, #ffbf00 18%, var(--bs-body-bg));                   --chip-fg: #ffbf00; }
        .icon-blue   { --chip-bg: color-mix(in oklab, var(--bs-primary) 14%, var(--bs-body-bg));         --chip-fg: var(--bs-primary); }

        /* Steps and tiles */
        .stat-tile { min-width: 120px; padding: .75rem 1rem; border-radius: .75rem; background: var(--bs-body-bg); border: 1px solid var(--bs-border-color); }
        .step-dot { width: 40px; height: 40px; border-radius: 12px; display: inline-flex; align-items: center; justify-content: center;
          font-weight: 700; background: var(--bs-primary-bg-subtle); color: var(--bs-primary); }

        /* Gradient surface that respects color mode */
        :root, [data-bs-theme="light"], [data-bs-theme="dark"] {
          --surface-1: color-mix(in oklab, var(--bs-primary) 10%, var(--bs-body-bg));
        }
          .carousel-control-next, .carousel-control-prev {
   
    filter: brightness(0.5);
 
}html { scroll-behavior: smooth; }

#market,#why-choose,#supported,#features,#faq
{
scroll-margin-top: 100px;
}

      `}</style>
    </div>
  );
}
